// 
import WebComponent from '../webComponents/WebComponent';

class RedirectToUrl extends WebComponent {
  constructor(props) {
    super(props);
    this.timer = null;
    this.stopTimer = this.stopTimer.bind(this);
    this.startTimer = this.startTimer.bind(this);
  }

  didMount() {
    const {
      url,
      stopTimerOnInputFocus,
      startTimerOnInputBlur,
    } = this.props;

    this.startTimer();

    // kliknuti nebo mousedown na manualni link stopne timer
    const manualLinks = this.element.querySelectorAll('a[href="' + url + '"]');
    if (manualLinks.length > 0) {
      Array.from(manualLinks).forEach(link => {
        link.addEventListener('click', this.stopTimer);
        link.addEventListener('mousedown', this.stopTimer);
      });
    }

    window.addEventListener('confirmPopupShow', this.stopTimer);
    window.addEventListener('confirmPopupHide', this.startTimer);

    if (stopTimerOnInputFocus || startTimerOnInputBlur) {
      this.formControls = document.querySelectorAll('.form-control');
      if (stopTimerOnInputFocus) {
        this.handleInputFocus();
      }
      if (startTimerOnInputBlur) {
        this.handleInputBlur();
      }
    }
  }

  willUnMount() {
    const {
      url,
    } = this.props;

    const manualLinks = this.element.querySelectorAll('a[href="' + url + '"]');
    if (manualLinks.length > 0) {
      Array.from(manualLinks).forEach(link => {
        link.removeEventListener('click', this.stopTimer);
        link.removeEventListener('mousedown', this.stopTimer);
      });
    }

    if (this.formControls.length > 0) {
      Array.from(this.formControls).forEach(formControl => {
        formControl.removeEventListener('focus', this.stopTimer);
        formControl.removeEventListener('blur', this.startTimer);
      });
    }

    this.stopTimer();
    this.timer = null;
  }

  startTimer() {
    const {
      url,
      timeout,
    } = this.props;

    const manualLinks = this.element.querySelectorAll('a[href="' + url + '"]');

    this.timer = setTimeout(() => {
      // disablovani butttonu pred provedenim automatickeho redirectu
      if (manualLinks.length > 0) {
        Array.from(manualLinks).forEach(link => {
          link.classList.add('disabled');
        });
      }

      // pokud neni uvedena url, provedeme reload sebe sama
      if (!url) {
        if (typeof(Turbolinks) != 'undefined') {
          Turbolinks.visit(window.location.toString(), { action: 'replace'})
        }
        else {
          window.location.reload();
        }
      }
      else {
        window.location.href = url;
      }


    }, timeout);
  }

  stopTimer() {
    clearTimeout(this.timer);
  }

  handleInputFocus() {
    if (this.formControls.length > 0) {
      Array.from(this.formControls).forEach(formControl => {
        formControl.addEventListener('focus', this.stopTimer);
      });
    }
  }
  handleInputBlur() {
    if (this.formControls.length > 0) {
      Array.from(this.formControls).forEach(formControl => {
        formControl.addEventListener('blur', this.startTimer);
      });
    }
  }
}

RedirectToUrl.defaultProps = {
  url: null,
  timeout: 10000,
  stopTimerOnInputFocus: true,
  startTimerOnInputBlur: true,
};

export default RedirectToUrl;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RedirectToUrl.js